import React from 'react';
import iWhiteLogo from '../assets/logo/iWhiteLogo.png';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="new-footer">
      <div className="new-container">
        <div className="new-footer-grid">
          
          {/* Col 1: Logo + Info */}
          <div className="new-footer-col new-footer-brand">
            <a href="/" className="new-footer-logo-link">
              <img 
                src={iWhiteLogo} 
                alt="Intellient Solutions" 
                className="new-footer-logo" 
              />
            </a>

            <p className="new-footer-tagline">
              Intelligence that empowers.<br/>Trust that endures.
            </p>

            <div className="new-footer-contact">
              <div>Riyadh, Kingdom of Saudi Arabia</div>
              <div>
                <a href="mailto:info@intellientsolutions.com">
                  info@intellientsolutions.com
                </a>
              </div>
            </div>

            {/* LinkedIn Button */}
            <a
              href="https://www.linkedin.com/company/intellient-solutions/"
              target="_blank"
              rel="noreferrer"
              className="new-linkedin-btn"
              aria-label="LinkedIn"
            >
              <svg viewBox="0 0 24 24" fill="#0a66c2" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" />
                <circle cx="4" cy="4" r="2" />
              </svg>
            </a>
          </div>

          {/* Col 2: Capabilities */}
          <div className="new-footer-col">
            <h4 className="new-footer-col-title">Capabilities</h4>
            <ul className="new-footer-links">
              <li><a href="/services">Services</a></li>
              <li><a href="/services">Data & AI</a></li>
              <li><a href="/services">Cloud Services</a></li>
              <li><a href="/services">Advanced Analytics</a></li>
              <li><a href="/services">Cybersecurity</a></li>
            </ul>
          </div>

          {/* Col 3: Company */}
          <div className="new-footer-col">
            <h4 className="new-footer-col-title">Company</h4>
            <ul className="new-footer-links">
              <li><a href="/about-us">About Us</a></li>
              <li><a href="/case-studies">Case Studies</a></li>
            </ul>
          </div>

          {/* Col 4: Connect */}
          <div className="new-footer-col">
            <h4 className="new-footer-col-title">Connect</h4>
            <ul className="new-footer-links">
              <li><a href="/contact">Contact Us</a></li>
              <li>
                <a 
                  href="https://www.linkedin.com/company/intellient-solutions/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </li>
              <li><a href="mailto:info@intellientsolutions.com">Email</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="new-footer-bottom">
          <span className="new-footer-copy">
            © 2026 Intellient Solutions · All Rights Reserved.
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;